import cn from 'clsx'
import {Space, Pagination} from 'antd'
import styles from './List.module.scss'
// import {isProjectRequest} from 'modules/project'
import {
  Box,
  Block,
  Text,
  Empty,
  UserAvatar,
  FolderBookmarkSecondIcon,
  RequestThirdIcon,
  SearchIcon,
} from 'common/components'
import {maybePluralize, formatDate} from 'common/helpers'
import {Organisation as OrgInterface} from '..'

interface ListProps {
  items: OrgInterface[]
  page: number
  total: number
  setPage?: (page: number) => void
}
interface OrgProps {
  item: OrgInterface
}
interface ProjectsProps {
  items: any[]
}

export const List:React.FC<ListProps> = ({
  items, 
  total, page, setPage,
}) => {
  return (
    (!items.length) ?
    <Empty title="search results"
      icon={<SearchIcon width={40} height={40} />}
    /> :
    <>
      <ul>
        {items.map((item) => (
          <Item key={item.uuid} item={item} />
        ))}
      </ul>
      { !!setPage &&
      <Pagination
        showSizeChanger={false}
        current={page}
        total={total}
        pageSize={10}
        onChange={setPage}
      />
      }
    </>
  )
}

const Item = ({item}: OrgProps) => {
  return (
    <Block as="li" className={cn(styles.item)}
      to={`/org/details/${item.id}`}
    >
      <div>
        <UserAvatar size={48} src={item.photo} alt={item.name} />
      </div>
      <div>
        <Text weight="demiBold">
          {item.name}
        </Text>
        <Text className={styles.details} size="xs" color="grey">
          <span>{item.email}</span>
          <br />
          <span>+64 {(!!item.phone && item.phone.length > 3) ? item.phone.slice(3) : item.phone}</span>
        </Text>
      </div>
      <Box align="center">
        <p className={styles.text}>ID {item.displayId}</p>
        <Text size="xs" color="grey">
          Registered {formatDate(item.createdAt, 'fifth')}
        </Text>
      </Box>
      <Box weight="demiBold" color={undefined}>
        <Space>Company</Space>
        <Box size="xs" weight="regular" mt={2}>
          {maybePluralize(item.users?.length ?? 0, 'member')}
        </Box>
      </Box>
      <Projects items={item.projects || []} />
      <Box style={{}} className={styles['item-projects']} >
        <RequestThirdIcon />
        <div>
          <Text size="md" weight="demiBold" mb={2}>
            {maybePluralize(item.requestsCount ?? 0, 'request')}
          </Text>
          <Text>&nbsp;</Text>
        </div>
      </Box>
      <Box align="right">
      { item.lendingManagers?.map((mngr:any, index:number) => (
        <UserAvatar key={index} size={24} src={mngr.photo} alt={'avatar'} />
      )) }
      </Box>
    </Block>
  )
}

const projectPostfix = (n:number) => ((n>1)?'projects':'project')

const Projects = ({items}: ProjectsProps) => {
  // const statusCount = {signed: 7, opened: 5, closed: 2}
  const statusCount = items?.reduce(
    (accu, item) => {
      if (
        ['opened'].includes(item.status)
      ) {
        accu.opened += 1
      } else if (
        ['closed'].includes(item.status)
      ) {
        accu.closed += 1
      }
      return accu
    },
    { opened: 0, closed: 0 } // declined, pending, ...
  )
  // console.table(items.map((x:any) => x.status))
  // console.log(statusCount)

  return (
    <>
      <Box className={styles['item-projects']} >
        <FolderBookmarkSecondIcon />
        <div>
          <Text size="md" weight="demiBold" mb={2}>
            {statusCount.opened}
            &nbsp;
            live
            &nbsp;
            {projectPostfix(statusCount.opened)}
          </Text>
          <Text size="xs" color="grayer">
            {statusCount.closed}
            &nbsp;
            closed
            &nbsp;
            {projectPostfix(statusCount.closed)}
          </Text>
        </div>
      </Box>

    </>
  )
}
